import { Record } from 'immutable';
import { Utils, C } from '@kineticdata/bundle-common';
const { withPayload } = Utils;
const ns = Utils.namespaceBuilder('services/appendix');

export const types = {
  FETCH_APPENDIX_REQUEST: ns('FETCH_APPENDIX_REQUEST'),
  FETCH_APPENDIX_SUCCESS: ns('FETCH_APPENDIX_SUCCESS'),
  FETCH_APPENDIX_FAILURE: ns('FETCH_APPENDIX_FAILURE'),
};

export const actions = {
  fetchAppendixRequest: withPayload(types.FETCH_APPENDIX_REQUEST),
  fetchAppendixSuccess: withPayload(types.FETCH_APPENDIX_SUCCESS),
  fetchAppendixFailure: withPayload(types.FETCH_APPENDIX_FAILURE),
};

export const State = Record({
  id: null,
  data: null,
  loading: false,
  error: null,
});

export const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_APPENDIX_REQUEST:
      return state
        .set('id', payload)
        .update(
          'data',
          d => (!d || d.values[C.FIELD_APPENDIX_ID] !== payload ? null : d),
        )
        .set('loading', true)
        .set('error', null);
    case types.FETCH_APPENDIX_SUCCESS:
      return payload.id === state.id
        ? state.set('data', payload.data).set('loading', false)
        : state;
    case types.FETCH_APPENDIX_FAILURE:
      return payload.id === state.id
        ? state.set('error', payload.error).set('loading', false)
        : state;
    default:
      return state;
  }
};

export default reducer;
